<div class="pwa-install-dialog">

  <!-- Header -->
  <h2 mat-dialog-title
      class="flex items-center gap-2 bg-pmdf-bg-subtle p-4 border-b border-pmdf-divider">
    <mat-icon class="text-pmdf-primary icon-base">install_mobile</mat-icon>
    <span class="text-pmdf-text-primary text-lg">Instalar Nexus PMDF</span>
  </h2>

  <!-- Content -->
  <mat-dialog-content class="dialog-content">
    <div class="flex flex-col items-center py-4">
      <img src="/img/logo/pmdf.svg" alt="PMDF" class="h-20 w-20 mb-4" />
      <p class="text-sm text-pmdf-muted-70 text-center mt-2 mb-2">
        Adicione o Nexus à tela inicial do seu celular para
        acesso rápido e receber notificações mesmo com o
        aplicativo fechado.
      </p>
    </div>
  </mat-dialog-content>

  <!-- Footer -->
  <mat-dialog-actions align="end"
      class="px-6 py-4 gap-2 bg-pmdf-bg-subtle border-t border-pmdf-divider flex flex-col w-full">
    <button mat-raised-button color="primary" type="button"
            class="w-full"
            (click)="instalar()">
      <mat-icon class="icon-sm">install_mobile</mat-icon>
      Instalar agora
    </button>
    <button mat-button type="button"
            class="w-full text-pmdf-muted-55"
            (click)="depois()">
      Agora não
    </button>
  </mat-dialog-actions>

</div>
